import { useCallback, useState } from 'react'
import { LaunchLinkScormRegistrationDocument } from 'generated/resources/graphql'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
interface UseScormLaunchParams {
  trainingMembershipId: string
}
interface UseScormLaunchResult {
  launchLink: string | null
  loading: boolean
  error: string | null
  launch: () => Promise<void>
  reset: () => void
}
export const useScormLaunch = ({
  trainingMembershipId,
}: UseScormLaunchParams): UseScormLaunchResult => {
  const [launchLink, setLaunchLink] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  const [getLaunchLink, { loading }] = useMutation(LaunchLinkScormRegistrationDocument, {
    extractorFn: (data) => data.trainingsMutations.launchLinkTrainingsScormRegistration,
  })

  const setErrorMessage = () => {
    setError(i18n.t('trainings.scorm.content.error'))
  }

  const launch = useCallback(async () => {
    setError(null)
    setLaunchLink(null)
    const result = await getLaunchLink({
      variables: { trainingMembershipId, redirectUrl: window.location.href },
    })
    const handled = handleResult(result, () => {
      setErrorMessage()
    })
    if (!handled.success) {
      setErrorMessage()
      return
    }
    setLaunchLink(handled.data.scormRegistration?.launchLink ?? null)
  }, [trainingMembershipId, getLaunchLink])

  const reset = useCallback(() => {
    setLaunchLink(null)
    setError(null)
  }, [])
  return {
    launchLink,
    loading: loading,
    error,
    launch,
    reset,
  }
}
